// import { createContext, useEffect, useReducer } from "react";

// const INITIAL_STATE = {
//   user: JSON.parse(localStorage.getItem("user")) || null,
//   loading: false,
//   error: null,
// };

// export const AuthContext = createContext(INITIAL_STATE);

// const AuthReducer = (state, action) => {
//   switch (action.type) {
//    case "LOGIN_SUCCESS":
//   return {
//     user: {
//       ...action.payload.user,
//       role: action.payload.role  
//     },
//     loading: false,
//     error: null,
//   };
//     case "LOGIN_SUCCESS":
//       return {
//         user: action.payload,
//         loading: false,
//         error: null,
//       };
//     case "LOGIN_FAILURE":
//       return {
//         user: null,
//         loading: false,
//         error: action.payload,
//       };
//     case "LOGOUT":
//       return {
//         user: null,
//         loading: false,
//         error: null,
//       };
//     default:
//       return state;
//   }
// };

// export const AuthContextProvider = ({ children }) => {
//   const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);

//   useEffect(() => {
//     localStorage.setItem("user", JSON.stringify(state.user));
//   }, [state.user]);

//   return (
//     <AuthContext.Provider
//       value={{
//         user: state.user,
//         loading: state.loading,
//         error: state.error,
//         dispatch,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };


//---------------------------------------Sachith---------------------------------------




import { createContext, useEffect, useReducer } from "react";

const INITIAL_STATE = {
  user: JSON.parse(localStorage.getItem("user")) || null,
  loading: false,
  error: null,
};

export const AuthContext = createContext(INITIAL_STATE);

const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_START":
      return {
        user: null,
        loading: true,
        error: null,
      };
    // In AuthContext.js - Update the LOGIN_SUCCESS case
case "LOGIN_SUCCESS":
  // Check if we have stored profile data for this user
  const userId = action.payload.user.userId || action.payload.user.id;
  const profileDataKey = `userProfile_${userId}`;
  let storedProfile = null;
  
  try {
    const profileData = localStorage.getItem(profileDataKey);
    if (profileData) {
      storedProfile = JSON.parse(profileData);
    }
  } catch (err) {
    console.error("Error loading profile data:", err);
  }

  return {
    user: {
      ...action.payload.user,
      ...storedProfile, // Merge stored profile data
      role: action.payload.role
    },
    loading: false,
    error: null,
  };
    case "LOGIN_FAILURE":
      return {
        user: null,
        loading: false,
        error: action.payload,
      };
    case "LOGOUT":
      return {
        user: null,
        loading: false,
        error: null,
      };
    // Add this to your AuthReducer switch statement
case "UPDATE_USER_PROFILE":
  return {
    ...state,
    user: {
      ...state.user,
      ...action.payload
    }
  };  
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);

  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(state.user));
  }, [state.user]);

  return (
    <AuthContext.Provider
      value={{
        user: state.user,
        loading: state.loading,
        error: state.error,
        dispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};